/**
 * Attempts to safely convert the error object in to a consistent, representable error object for
 * use with logging.
 * @arg error: The error object to convert.
 * @returns a record object filled out with the best information available or null if it was not
 * able to convert the object safely.
 */
export function safeGetError(error: unknown) {
  if (error instanceof Error) {
    return {
      error: error.message,
      name: error.name,
      stack: error.stack,
    };
  }

  if (typeof error === 'string') {
    return { error, name: 'string' };
  }

  if (typeof error === 'object' && error) {
    let message = '';
    let stack = '';

    if (typeof error.toString === 'function' && Object.prototype.toString !== error.toString) {
      message = error.toString();
    }

    if ('stack' in error) {
      stack = error.stack as string;
    }

    if (message || stack) {
      return {
        error: message,
        name: 'object',
        stack,
      };
    }

    try {
      return {
        error: JSON.stringify(error, null, 0),
        name: 'json',
      };
    } catch {
      return null;
    }
  }

  return null;
}
